// @ts-strict-ignore
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '../convert/model-conversion.service';
import { map } from 'rxjs/operators';
import { ProductionPlantVO } from '@project/model/vo/production-plant.vo';
import { CountryCodeVO } from '../vo/country-code.vo';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProductionPlantDataService {
  private readonly getAllProductionPlantsUrl: string = 'production-plant/';
  private readonly getAllCountryCodesUrl: string = 'production-plant/countryCodes';

  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) {}

  public getAllProductionPlants(): Observable<ProductionPlantVO[]> {
    return this.wagoApiClient
      .get(this.getAllProductionPlantsUrl)
      .pipe(map((response: any[]) => this.modelConversionService.convertProductionPlantsVOs(response)));
  }

  public getAllCountryCodes(): Observable<CountryCodeVO[]> {
    return this.wagoApiClient
      .get(this.getAllCountryCodesUrl)
      .pipe(map((response: any[]) => this.modelConversionService.convertCountryCodeVOs(response)));
  }
}
